import React from "react";
import { Link } from "react-router-dom";
import { Check, MessageCircle, Video, Lock, Calendar, ArrowRight } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/api";

const helpItems = [
  { emoji: "😰", label: "Ansiedade" },
  { emoji: "💭", label: "Angústia" },
  { emoji: "🌧️", label: "Tristeza persistente" },
  { emoji: "🪞", label: "Baixa autoestima" },
  { emoji: "💔", label: "Dificuldades nos relacionamentos" },
  { emoji: "🫧", label: "Sofrimento emocional" },
  { emoji: "🏠", label: "Conflitos familiares" },
  { emoji: "🎒", label: "Adolescência" },
  { emoji: "🌫️", label: "Sentimento de vazio" },
  { emoji: "🦋", label: "Processos de autoconhecimento" },
];

export default function Psicanalise() {
  return (
    <div data-testid="page-psicanalise">
      <section className="section">
        <div className="container-narrow">
          <div className="max-w-3xl">
            <span className="text-eyebrow">A psicanálise como caminho</span>
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl mt-5 leading-[1.1] text-[#2C352D]">
              Como a psicanálise<br /> pode ajudar você.
            </h1>
            <p className="mt-8 text-[#5B685C] text-lg leading-relaxed font-light">
              A psicanálise oferece um espaço dedicado de fala e escuta, em que aquilo que aperta, dói ou
              confunde pode ganhar palavras e novos sentidos. Não se trata de receitas: cada sujeito é único,
              e cada análise constrói seu próprio percurso.
            </p>
          </div>

          <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {helpItems.map((item, i) => (
              <div
                key={item.label}
                data-testid={`psicanalise-help-${i}`}
                className="bg-white rounded-2xl border border-[#8BA88E]/15 px-6 py-5 flex items-center gap-4 soft-shadow"
              >
                <span className="h-11 w-11 rounded-full bg-[#8BA88E]/10 flex items-center justify-center text-2xl leading-none shrink-0" aria-hidden="true">
                  {item.emoji}
                </span>
                <span className="text-[#2C352D] font-light">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-[#F5F5ED]">
        <div className="container-narrow grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <img
              src="https://images.unsplash.com/photo-1588091209794-8aa1768e2937?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxsYXB0b3AlMjBjb2ZmZWUlMjBjYWxtJTIwZGVzayUyMG9ubGluZXxlbnwwfHx8fDE3ODI1ODg1MTd8MA&ixlib=rb-4.1.0&q=85"
              alt="Atendimento online"
              className="rounded-[2rem] w-full h-[460px] object-cover soft-shadow"
              data-testid="psicanalise-online-image"
            />
          </div>
          <div className="lg:col-span-6">
            <span className="text-eyebrow">Atendimento Online</span>
            <h2 className="font-serif text-4xl md:text-5xl mt-5 text-[#2C352D] leading-tight">
              Como acontecem as sessões online.
            </h2>
            <p className="mt-6 text-[#5B685C] font-light leading-relaxed">
              As sessões acontecem por videochamada, em plataforma segura. Você só precisa de um lugar
              tranquilo, conexão estável e a disposição para falar.
            </p>
            <div className="mt-8 space-y-5">
              <div className="flex gap-4">
                <Video className="text-[#8BA88E] shrink-0 mt-1" size={22} />
                <div>
                  <h4 className="font-serif text-xl text-[#2C352D]">Plataforma</h4>
                  <p className="text-[#5B685C] font-light">Google Meet ou Zoom, com link enviado antes de cada sessão.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <Lock className="text-[#8BA88E] shrink-0 mt-1" size={22} />
                <div>
                  <h4 className="font-serif text-xl text-[#2C352D]">Privacidade</h4>
                  <p className="text-[#5B685C] font-light">Sigilo absoluto, ambiente reservado e ética psicanalítica.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <Calendar className="text-[#8BA88E] shrink-0 mt-1" size={22} />
                <div>
                  <h4 className="font-serif text-xl text-[#2C352D]">Frequência</h4>
                  <p className="text-[#5B685C] font-light">Em geral semanal — definimos juntos no início do processo.</p>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap gap-4">
              <a
                data-testid="psicanalise-whatsapp-btn"
                href={WHATSAPP_LINK("Olá Cristina, gostaria de saber mais sobre o atendimento online.")}
                target="_blank"
                rel="noreferrer"
                className="btn-whatsapp"
              >
                <MessageCircle size={18} /> Agendar pelo WhatsApp
              </a>
              <Link data-testid="psicanalise-adolescentes-link" to="/adolescentes" className="btn-outline">
                Atendimento adolescentes <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
